import React from "react"

import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Separator } from "@/components/ui/separator"
import { Application } from "@/contexts/ApplicationContext"

interface VehicleInformationSectionProps {
  application: Application
  setApplication: (app: Application) => void
}

const VehicleInformationSection: React.FC<VehicleInformationSectionProps> = ({
  application,
  setApplication,
}) => {
  return (
    <div className="mb-6 space-y-4">
      <div className="flex items-center px-6 pt-6">
        <h2 className="text-lg font-bold text-jungle">Vehicle Information</h2>
      </div>
      <Separator className="mt-2" />

      <div className="bg-transparent p-6">
        <div className="space-y-3">
          <Label className="text-sm font-medium md:text-base">
            Do you have your own electric van?
          </Label>
          <RadioGroup
            value={
              application.basicDetails.ownElectricVan === true
                ? "yes"
                : application.basicDetails.ownElectricVan === false
                  ? "no"
                  : ""
            }
            onValueChange={(value) => {
              const hasVan = value === "yes"
              setApplication({
                ...application,
                basicDetails: {
                  ...application.basicDetails,
                  ownElectricVan: hasVan ? true : value === "no" ? false : undefined,
                  needsVan: hasVan ? false : application.basicDetails.needsVan,
                },
              })
            }}
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="yes" id="own-van-yes" />
              <Label htmlFor="own-van-yes" className="text-sm">
                Yes
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="no" id="own-van-no" />
              <Label htmlFor="own-van-no" className="text-sm">
                No
              </Label>
            </div>
          </RadioGroup>
        </div>

        {application.basicDetails.ownElectricVan === false && (
          <div className="mt-4 space-y-3">
            <Label className="text-sm font-medium md:text-base">
              Do you need HIVED to provide you a van?
            </Label>
            <RadioGroup
              value={
                application.basicDetails.needsVan === true
                  ? "yes"
                  : application.basicDetails.needsVan === false
                    ? "no"
                    : ""
              }
              onValueChange={(value) =>
                setApplication({
                  ...application,
                  basicDetails: {
                    ...application.basicDetails,
                    needsVan: value === "yes" ? true : value === "no" ? false : undefined,
                  },
                })
              }
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="yes" id="need-van-yes" />
                <Label htmlFor="need-van-yes" className="text-sm">
                  Yes
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="no" id="need-van-no" />
                <Label htmlFor="need-van-no" className="text-sm">
                  No
                </Label>
              </div>
            </RadioGroup>
          </div>
        )}
      </div>
    </div>
  )
}

export default VehicleInformationSection
